import { openDB } from "idb";
import { TELEMETRY_DB_NAME, TELEMETRY_DB_VERSION, TELEMETRY_STORE } from "./constants";

let dbPromise;

const getDb = () => {
  if (!dbPromise) {
    dbPromise = openDB(TELEMETRY_DB_NAME, TELEMETRY_DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(TELEMETRY_STORE)) {
          const store = db.createObjectStore(TELEMETRY_STORE, {
            keyPath: "id",
            autoIncrement: true,
          });
          store.createIndex("byCreatedAt", "createdAt");
          store.createIndex("byEventType", "eventType");
        }
      },
    });
  }

  return dbPromise;
};

export const addTelemetryEvent = async (event) => {
  const db = await getDb();
  return db.add(TELEMETRY_STORE, event);
};

export const getTelemetryEvents = async (limit = 100) => {
  const db = await getDb();
  const tx = db.transaction(TELEMETRY_STORE, "readonly");
  const store = tx.objectStore(TELEMETRY_STORE);
  const all = await store.getAll();
  await tx.done;
  return all
    .sort((a, b) => a.createdAt - b.createdAt)
    .slice(0, Math.max(1, limit));
};

export const deleteTelemetryEvents = async (ids = []) => {
  if (!ids.length) {
    return;
  }

  const db = await getDb();
  const tx = db.transaction(TELEMETRY_STORE, "readwrite");
  for (const id of ids) {
    await tx.objectStore(TELEMETRY_STORE).delete(id);
  }
  await tx.done;
};

export const getTelemetryQueueSize = async () => {
  const db = await getDb();
  return db.count(TELEMETRY_STORE);
};
